import useCasesJson from '../../../data/topics/use-cases.json';
import platformsJson from '../../../data/topics/platforms.json';
import featuresJson from '../../../data/topics/features.json';
import {currentYear, replaceYearDeep} from '../replace-year';

export interface TopicFeature {
  title: string;
  body: string;
}

export interface Topic {
  slug: string;
  name: string;
  metaTitle: string;
  metaDescription: string;
  whyItMatters: string[];
  features: TopicFeature[];
}

export type TopicGroup = 'use-cases' | 'platforms' | 'features';

const GROUP_LABELS: Record<TopicGroup, string> = {
  'use-cases': 'Use Cases',
  platforms: 'Platforms',
  features: 'Features',
};

const year = currentYear();
const GROUPS: Record<TopicGroup, Record<string, Topic>> = {
  'use-cases': replaceYearDeep(
    useCasesJson as unknown as Record<string, Topic>,
    year,
  ),
  platforms: replaceYearDeep(
    platformsJson as unknown as Record<string, Topic>,
    year,
  ),
  features: replaceYearDeep(
    featuresJson as unknown as Record<string, Topic>,
    year,
  ),
};

export function getTopic(
  group: TopicGroup,
  slug?: string,
  sub?: string,
): Topic | null {
  if (!slug) return null;
  const key = sub ? `${slug}/${sub}` : slug;
  return GROUPS[group]?.[key] || null;
}

export function getAllTopics(group: TopicGroup): Topic[] {
  return Object.values(GROUPS[group] || {});
}

export function getGroupLabel(group: TopicGroup): string {
  return GROUP_LABELS[group] || group;
}
